import { Alert, CircularProgress, Grid, Icon, Snackbar } from "@mui/material";

import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
//import Alert from "@mui/material/lab/Alert";
import React, { useEffect } from "react";
import { StandardButton, StandardText } from "./standard";
import { FieldText } from "./forms";
import { Dialog } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

export const Alert1 = function (props) {
  const classes = useStyles();
  const { severity, description, onClose, open } = props;

  return (
    <div className={classes.root}>
      <Snackbar
        //anchorOrigin={{ vertical: "center", horizontal: "top" }}
        open={true}
        autoHideDuration={3000}
        onClose={() => {
          //setOpen(false);
          onClose();
        }}
      >
        <Alert onClose={() => onClose()} severity={severity}>
          {description}
        </Alert>
      </Snackbar>
    </div>
  );
};

export function AlertBox(props) {
  const [open, setOpen] = React.useState(true);
  const { title, description, onClose, closeText } = props;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (t) => {
    if (t) return;
    if (onClose) onClose();
    setOpen(false);
  };

  const id1 = "alert-dialog-slide-title" + Date.now();
  const id2 = "alert-dialog-slide-description" + Date.now();

  return (
    <div>
      <Dialog
        open={open}
        closeAfterTransition={false}
        slots={{ transition: Transition }}
        keepMounted
        disableEscapeKeyDown
        onClose={handleClose}
        aria-labelledby={id1}
        aria-describedby={id2}
      >
        <DialogTitle id={id1}>
          <StandardText regular={1} startIcon={<Icon>priority_high</Icon>}>
            {title}
          </StandardText>
        </DialogTitle>

        <DialogContent dividers>
          <DialogContentText component="div" id={id2}>
            {description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <StandardButton onClick={() => handleClose(false)}>
            <StandardText color="primary" size={12} bold={1}>
              {closeText || "Fechar"}
            </StandardText>
          </StandardButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const AlertDialog = React.memo(({ open, onClose, params }) => {
  const { title, description, onClose: localOnClose, closeText } = params || {};

  const handleClose = (t) => {
    if (t) return;
    if (localOnClose) localOnClose();
    if (onClose) onClose("alertDialog");
    //setOpen(false);
  };

  const id1 = "alert-dialog-slide-title" + Date.now();
  const id2 = "alert-dialog-slide-description" + Date.now();

  return (
    <Dialog
      style={{ zIndex: 9999999 }}
      open={open}
      closeAfterTransition={false}
      slots={{ transition: Transition }}
      keepMounted
      disableEscapeKeyDown
      onClose={handleClose}
      aria-labelledby={id1}
      aria-describedby={id2}
    >
      <DialogTitle id={id1}>
        <StandardText regular={1} startIcon={<Icon>priority_high</Icon>}>
          {title}
        </StandardText>
      </DialogTitle>

      <DialogContent dividers>
        <DialogContentText component="div" id={id2}>
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <StandardButton onClick={() => handleClose(false)}>
          <StandardText color="primary" size={12} bold={1}>
            {closeText || "Fechar"}
          </StandardText>
        </StandardButton>
      </DialogActions>
    </Dialog>
  );
});

export const ConfirmDialog = React.memo(({ open, onClose, params }) => {
  const { title, description, confirmText, closeText, onConfirm, onUnconfirm } =
    params || {};
  //const [open, setOpen] = React.useState(false);

  const handleClose = (t) => {
    if (!t) return;
    if (onUnconfirm) onUnconfirm();
    if (onClose) onClose("confirmDialog");
    //setOpen(false);
  };

  const handleConfirm = () => {
    onConfirm();
    if (onClose) onClose("confirmDialog");
  };

  const id1 = "alert-dialog-slide-title-aa" + Date.now();
  const id2 = "alert-dialog-slide-description-aa" + Date.now();

  return (
    <Dialog
      style={{ zIndex: 9999999 }}
      open={open}
      closeAfterTransition={false}
      slots={{ transition: Transition }}
      keepMounted
      disableEscapeKeyDown
      //disableBackdropClick
      onClose={() => handleClose(false)}
      aria-labelledby={id1}
      aria-describedby={id2}
    >
      <DialogTitle id={id1}>{title}</DialogTitle>
      <DialogContent dividers>
        <DialogContentText component="div" id={id2}>
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <StandardButton onClick={handleConfirm}>
          <StandardText size={14} color="secondary" bold={1}>
            {confirmText || "Confirmar"}
          </StandardText>
        </StandardButton>
        <StandardButton onClick={() => handleClose(true)}>
          <StandardText size={14} color="primary" bold={1}>
            {closeText || "Fechar"}
          </StandardText>
        </StandardButton>
      </DialogActions>
    </Dialog>
  );
});

export const LoadingDialog = React.memo(({ open, onClose, params }) => {
  const { title, description, dismissible } = params || {};

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  const handleClose = () => {
    if (!dismissible) return;
    if (onClose) onClose("loadingDialog");
  };

  const id1 = "alert-dialog-slide-title" + Date.now();
  const id2 = "alert-dialog-slide-description" + Date.now();

  return (
    <Dialog
      style={{ zIndex: 9999998 }}
      open={open}
      slots={{ transition: Transition }}
      closeAfterTransition={false}
      //keepMounted
      disableEscapeKeyDown
      onClose={handleClose}
      aria-labelledby={id1}
      aria-describedby={id2}
    >
      <DialogTitle id={id1}>{title || "Processando"}</DialogTitle>
      <DialogContent
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <CircularProgress />
        &nbsp;&nbsp;
        <DialogContentText>{description || "Aguarde..."}</DialogContentText>
      </DialogContent>
    </Dialog>
  );
});

export const InputDialog = React.memo(({ open, onClose, params }) => {
  //const [open, setOpen] = React.useState(true);

  const {
    title,
    description,
    placeholder,
    onClose: localOnClose,
    confirmText,
    defaultValue,
    keyboard,
    closeText,
    mask,
    onConfirm,
  } = params || {};

  const handleClose = (t) => {
    if (!t) return;
    refs.value.value = "";
    if (localOnClose) localOnClose();
    if (onClose) onClose("inputDialog");
    //setOpen(false);
  };

  const handleOnChange = () => {
    const { value } = refs.value;

    if (value.length) {
      onConfirm(value);
      refs.value.value = "";
    }
  };

  const refs = {};

  const id1 = "alert-dialog-slide-title" + Date.now();
  const id2 = "alert-dialog-slide-description" + Date.now();

  useEffect(() => {
    if (open) {
      refs.value.focus();
      refs.value.value = defaultValue || "";
    }
  }, [open]);

  return (
    <Dialog
      style={{ zIndex: 9999999 }}
      open={open}
      closeAfterTransition={false}
      slots={{ transition: Transition }}
      keepMounted
      disableEscapeKeyDown
      //disableBackdropClick
      onClose={() => handleClose(false)}
      aria-labelledby={id1}
      aria-describedby={id2}
    >
      <DialogTitle id={id1}>{title}</DialogTitle>
      <DialogContent dividers>
        <DialogContentText component="div" id={id2}>
          {description}
        </DialogContentText>
        <Grid container>
          <FieldText
            keyboard={keyboard}
            defaultValue={defaultValue}
            forwardRef={(ref) => (refs.value = ref)}
            xs={12}
            onChange={(e) => {
              if (mask) mask(e.target);
            }}
            placeholder={placeholder || "Seu texto aqui"}
          />
        </Grid>
      </DialogContent>
      <DialogActions>
        <StandardButton onClick={handleClose}>
          <StandardText size={12} color="primary" bold={1}>
            {closeText || "Fechar"}
          </StandardText>
        </StandardButton>
        <StandardButton disabled={!!refs.value} onClick={handleOnChange}>
          <StandardText color="secondary" bold={1} size={12}>
            Confirmar
          </StandardText>
        </StandardButton>
      </DialogActions>
    </Dialog>
  );
});
